import React from 'react';
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as rootActions } from '../actions'
import { NAME as ROOT_NAME } from '../../Root/reducer'
import { isSaving } from '../../Root/saving'
import { NAME as PRODUCT_TYPE_NAME } from '../reducer'
import {Button, TextField} from '@material-ui/core'

import ResponsiveDrawer from "../../../components/ResponsiveDrawer"
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import { cropNameError } from '../cropName'

function mapStateToProps(state) {
    return {
        ...state[PRODUCT_TYPE_NAME],
        saving: isSaving(state[ROOT_NAME], 'PRODUCT_TYPE_CREATE')
    }
}


const mapDispatchToProps = (dispatch) => bindActionCreators({
    ...rootActions,
}, dispatch)

function validate(selector){
  // name validation: given, and not the name of a crop that is already there
  const problem = cropNameError(selector.state.productName, selector.props.productTypeList)
  selector.setState({ errorProductName: Boolean(problem), helperTextProductName: problem })
  return !problem
}

class CreateProductType extends React.Component {
    constructor(props) {
        super(props);
        props.getProductTypeList()
        this.state = {
          errorProductName: false,
          helperTextProductName: ""
        }
    }
    render() {
      return(
        <Grid component={Paper} container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <Typography variant={'h5'} align={'center'}>
                Создание товара
              </Typography>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
            <TextField 
              id="outlined-basic" 
              label="Название культуры" 
              variant="outlined"
              error={this.state.errorProductName}
              helperText={this.state.helperTextProductName}
              onChange={e => this.setState({ productName: e.target.value, errorProductName: false, helperTextProductName: "" })}
              onBlur={e => {
                // Повтор названия видно сразу, как человек вышел из поля (пустое поле не ругаем).
                const problem = e.target.value.trim() ? cropNameError(e.target.value, this.props.productTypeList) : ""
                this.setState({ errorProductName: Boolean(problem), helperTextProductName: problem })
              }}
            />
            </FormControl>
            </Grid>
            <Grid item xs={12}>
            <FormControl fullWidth>
            <Button variant='contained' color='Primary' disabled={this.props.saving} onClick={()=>{
              if (validate(this)){
                this.props.createProductType({productName: this.state.productName})
              }
            }}>Добавить</Button>
            </FormControl>
            </Grid>

        </Grid>
      )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateProductType)
